import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';

import { DocumentService } from '../../services/document-service';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast-service';
import { TaskStatusResponse } from '../../shared/interfaces';
import { TaskService } from '../../services/task-service';

@Component({
  selector: 'app-header',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class Header {
  public taskService = inject(TaskService);
  public authService = inject(AuthService);
  public toastService = inject(ToastService);

  taskState = this.taskService.taskState;
  user = toSignal(this.authService.user$);

  isModalOpen = signal(false);

  // Apre SEMPRE la modale, a prescindere dallo status
  handleTaskClick(task: TaskStatusResponse) {
    this.isModalOpen.set(true);
  }

  // --- LOGICA MODALE CUSTOM ---
  closeModal() {
    this.isModalOpen.set(false);
  }

  confirmDismissTask() {
    this.taskService.dismissTask();
    this.closeModal();
    this.toastService.show('Notifica del task rimossa.', 'success');
  }

  getCountByStatus(status: 'SUCCESS' | 'ERROR'): number {
    const results = this.taskState()?.results;
    if (!results) return 0;
    return results.filter(r => r.status === status).length;
  }

  // --- LOGICA UTENTE ---
  getInitials(firstName?: string, lastName?: string): string {
    const first = firstName?.charAt(0) || '';
    const last = lastName?.charAt(0) || '';
    return (first + last).toUpperCase() || 'U'; 
  }

  logout() {
    this.authService.logout();
  }
}